export default __webpack_public_path__ + "static/media/alerta.f1915b27.svg";